import React, {Component} from 'react';
import Main from '../Main';
import { path_create_role } from '../../routes/Pathnames';
import {Link} from 'react-router-dom';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {setLoadingGetRoles, getRoles, getRolesSuccess, getRolesError,
    setLoadingDeleteRole, deleteRole, deleteRoleSuccess, deleteRoleError} from '../../actions/RoleActions';
import {TRANSLATE_LIST_OF_ROLES, TRANSLATE_ID, TRANSLATE_ROLE_NAME, TRANSLATE_ADD_NEW_ROLE, 
    TRANSLATE_QUESTION_DELETE_ROLE} from '../../translates/Translates';

class ListRoles extends Component{
    constructor(props){
        super(props);

        this.state = {
            roles: []
        }
    }

    componentDidMount = () => {
        this.props.setLoadingGetRoles();
        this.props.getRoles().then((response) => {
            this.setState({roles: response.payload.data});
            this.props.getRolesSuccess();
        }).catch(() => {
            this.props.getRolesError();
        })
    }

    handleClickDeleteRole = (id) => {
        if(window.confirm(TRANSLATE_QUESTION_DELETE_ROLE)){
            this.props.setLoadingDeleteRole();
            this.props.deleteRole(id)
            .then(() => {
                this.props.deleteRoleSuccess();
            }).catch(() => {
                this.props.deleteRoleError();
            })
        }
    }

    render(){
        return(
            <div>
                <Main/>
                <div className="page-wrapper ">
                    <div className="container-fluid">
                        <br />
                        <div className="row page-tier3">
                            <div className="col s12">
                                <div className="card card-outline-info">
                                    <div className="card-header">
                                        <h4 className="mb-0 text-white">{TRANSLATE_LIST_OF_ROLES}</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="table-responsive">
                                            {this.props.loadingGetRoles ? (
                                            <table id="demo-foo-addrow" className="table mt-4 table-hover no-wrap contact-list">
                                                <tbody>
                                                    <tr className="preloader-tr">
                                                        <td colSpan="12" className="preloader">
                                                            <svg className="circular" viewBox="25 25 50 50">
                                                                <circle className="path" cx="50" cy="50" r="20" fill="none" />
                                                            </svg>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="2">
                                                            <br/>
                                                            <Link to={path_create_role} className="btn btn-info btn-rounded" data-toggle="modal" data-target="#add-contact">{TRANSLATE_ADD_NEW_ROLE}</Link>
                                                        </td>
                                                        <td colSpan="10"></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            ) : (
                                            <table id="demo-foo-addrow" className="table mt-4 table-hover no-wrap contact-list"> 
                                                <thead>
                                                    <tr>
                                                        <th></th>
                                                        <th>{TRANSLATE_ID}</th>
                                                        <th>{TRANSLATE_ROLE_NAME}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.roles.map((role, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="list-users-delete-td">
                                                                <button type="button" onClick={() => this.handleClickDeleteRole(role.id)} className="list-users-delete-button">
                                                                    <i className="ti-close-td fas fa-times"></i>
                                                                </button>
                                                            </td>
                                                            <td>{role.id}</td>
                                                            <td>
                                                                <Link to={'/edit-role/' + role.id}>{role.name}</Link>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td colSpan="2">
                                                            <br/>
                                                            <Link to={path_create_role} className="btn btn-info btn-rounded" data-toggle="modal" data-target="#add-contact">{TRANSLATE_ADD_NEW_ROLE}</Link>
                                                        </td>
                                                        <td colSpan="10"></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        loadingGetRoles: state.roleReducer.loadingGetRoles
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setLoadingGetRoles,
        getRoles,
        getRolesSuccess,
        getRolesError,
        setLoadingDeleteRole,
        deleteRole,
        deleteRoleSuccess,
        deleteRoleError
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ListRoles);
